import React from 'react';
import { motion } from 'framer-motion';
import { Timer, ArrowRight } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function PricingSection() {
  return <section id="pricing" className="py-20 px-4 bg-brand-cream relative overflow-hidden" data-id="element-115">
      <div className="max-w-3xl mx-auto relative z-10" data-id="element-116">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="bg-white p-8 md:p-12 rounded-3xl shadow-2xl border-4 border-brand-gold/20 text-center" data-id="element-117">
          <div className="inline-flex items-center justify-center gap-2 bg-brand-coral/10 text-brand-coral px-4 py-2 rounded-full text-sm font-bold tracking-wider uppercase mb-8 animate-pulse" data-id="element-118">
            <Timer className="w-4 h-4" data-id="element-119" />
            Oferta por tiempo limitado
          </div>

          <div className="mb-8" data-id="element-120">
            <p className="text-xl text-brand-navy/60 mb-2 font-medium" data-id="element-121">
              Valor Total del Paquete:
            </p>
            <p className="text-3xl text-brand-navy/40 line-through font-bold decoration-brand-coral/50 decoration-4" data-id="element-122">
              $292 USD
            </p>
          </div>

          <div className="mb-10" data-id="element-123">
            <p className="text-2xl text-brand-navy mb-2 font-bold" data-id="element-124">
              Tu inversión hoy:
            </p>
            <div className="flex items-center justify-center gap-4" data-id="element-125">
              <span className="text-6xl md:text-8xl font-black text-brand-teal tracking-tighter" data-id="element-126">
                $6.39
              </span>
              <span className="text-2xl font-bold text-brand-teal/80 mt-4" data-id="element-127">
                USD
              </span>
            </div>
          </div>

          <div className="bg-brand-muted p-6 rounded-2xl mb-10 border border-brand-navy/5" data-id="element-128">
            <p className="text-lg text-brand-navy/80 italic font-serif" data-id="element-129">
              (Eso es menos de lo que cuesta una salida a comer pizza, pero con
              un impacto que durará toda la vida de tu hijo).
            </p>
          </div>

          <CTAButton className="mb-6" href="https://pay.hotmart.com/I105257953Q?off=p3on1myk&bid=1775510463890" data-id="element-130" />

          <div className="flex items-center justify-center gap-2 text-sm text-brand-navy/60" data-id="element-131">
            <ArrowRight className="w-4 h-4" data-id="element-132" />
            Acceso inmediato y de por vida
          </div>
        </motion.div>
      </div>
    </section>;
}